import { JSX } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { SerendieSymbol } from "@serendie/symbols";
import { ConfirmDialog } from "../../Dialogs/ConfirmDialog/ConfirmDialog";
import { Button, IButtonProps } from "../Button/Button";

export class DeleteButton extends BaseComponent<IDeleteButtonProps, IDeleteButtonState>
{
    public static buttonLabel = '';
    public static dialogTitle = '';
    public static dialogMessage = '';
    public static dialogConfirmDeleteLabel = '';

    constructor(props: IDeleteButtonProps)
    {
        super(props);
        this.state =
        {
            showConfirmationDialog: false,
        };
    }

    private handleDeleteClick(): void
    {
        this.setState({ showConfirmationDialog: true });
    }

    private async onDeleteConfirm(): Promise<void>
    {
        await this.props.onDelete();
        this.setState({ showConfirmationDialog: false });
    }

    public render(): JSX.Element
    {
        const { onDelete, ref, small, rightIcon, dialogTitle, dialogMessage, buttonLabel, dialogConfirmDeleteLabel, ...buttonProps } = this.props;

        return <>
            <Button
                size={small ? 'small' : undefined}
                styleType={small ? 'ghost' : 'filled'}
                leftIcon={small ? <SerendieSymbol name='trash' /> : undefined}
                color='error'
                {...buttonProps}
                onClick={() => this.handleDeleteClick()}
            >
                {buttonLabel ?? DeleteButton.buttonLabel}
            </Button>
            <ConfirmDialog
                show={this.state.showConfirmationDialog}
                header={dialogTitle ?? DeleteButton.dialogTitle}
                content={dialogMessage ?? DeleteButton.dialogMessage}
                okButtonLabel={dialogConfirmDeleteLabel ?? DeleteButton.dialogConfirmDeleteLabel}
                confirmButtonColor='error'
                confirmButtonIcon={<SerendieSymbol name='trash' />}
                onConfirm={() => this.onDeleteConfirm()}
                onClose={() => this.setState({ showConfirmationDialog: false })}
            />
        </>;
    }
}

export type IDeleteButtonProps = IButtonProps &
{
    buttonLabel?: string;
    dialogTitle?: string;
    dialogMessage?: string;
    dialogConfirmDeleteLabel?: string;
    onDelete: () => Promise<void>;
    small?: boolean;
}

export interface IDeleteButtonState
{
    showConfirmationDialog: boolean;
}
